import { useRef } from 'react';
import { NotificationsSidebar } from './NotificationsSidebar';
import { StyledSidebar, StyledSidebarContent } from './styled';

import useClickAway from '@/utils/hooks/useClickAway';
import { MenuSidebar } from './MenuSidebar';
import { SearchSidebar } from './search/SearchSidebar';

function Sidebar({ onClickAway, type }) {
  const wrapperRef = useRef();
  useClickAway(onClickAway, wrapperRef);

  if (!type || type === 'none') return null;

  return (
    <div ref={wrapperRef}>
      <StyledSidebar>
        <StyledSidebarContent
          className="scroll-wrapper"
          data-simplebar
          data-simplebar-auto-hide="true"
        >
          {/** simplebar does not like when you take away its child and crashes, a wrapping div works. This could be investigated later */}
          <div>
            {type === 'menu' && <MenuSidebar />}
            {type === 'comments' && <NotificationsSidebar />}
            {type === 'search' && <SearchSidebar hideSidebar={onClickAway} />}
          </div>
        </StyledSidebarContent>
      </StyledSidebar>
    </div>
  );
}

export default Sidebar;
